module.exports = __webpack_public_path__ + "img/youhui.d323baf6.png";